import { useMatches, useNavigate, useParams } from 'react-router-dom'
import {
  DashboardhMediumButton,
  DashboardMessage,
} from 'bd-web-components'

import {
  Container,
  FormDivider,
  TextHeaderBox,
  PageTitle,
  PageHeaderBox,
  PageSubtitle,
  ButtonHeaderBox,
  TableContainer,
  ExceptionContainer,
} from '../../styles/page-styles/styles'

import { useEffect, useRef, useState } from 'react'
import { SECONDARY_BLUE_01 } from 'bd-web-components/src/utils/dash-colors'
import Loader from '../../components/Loader'
import { useGetCourtesiesList } from '../../hooks/courtesies-list'
import { useGetProducerPDV } from '../../hooks/producer-pdv'
import { errorRedirect } from '../../utils/redirect'
import { Breadcrumb } from '../../components/Breadcrumb'

import TablePagination from '../../components/TablePagination'
import CourtesyTable from '../../components/CourtesyTable'


export function CourtesyList() {
  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })


  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [sentCortesiesData, SetSentCortesiesData] = useState<any | null>(null)
  const tabelaRef: any = useRef(null)


  const handlePaginaChange = (page: any) => {
    setPage(page + 1)
    if (tabelaRef.current) {
      tabelaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const { sentCourtesies, sentCourtesiesLoading, sentCourtesiesError } =
    useGetCourtesiesList(id as string, page.toString())
  const { producerPDV, producerPDVLoading, producerPDVError } =
    useGetProducerPDV(id as string)

  useEffect(() => {
    if (producerPDVError !== undefined) {
      errorRedirect(
        '/error',
        {
          message: 'Não existem cortesias para esse evento',
          tittle: 'Não permitido',
        },
        navigate
      )
    }
  }, [producerPDV, producerPDVLoading, producerPDVError, navigate])

  useEffect(() => {
    if (sentCourtesies !== undefined) {
      SetSentCortesiesData(sentCourtesies)
    }
  }, [sentCourtesies, sentCourtesiesLoading, sentCourtesiesError])

  const success =
    !sentCourtesiesError && !sentCourtesiesLoading && sentCortesiesData !== null
  const loading = !sentCourtesiesError && sentCourtesiesLoading
  const error = sentCourtesiesError && !sentCourtesiesLoading

  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>Cortesias Enviadas</PageTitle>
            <PageSubtitle>
              Nesta página ficam as cortesias desse evento enviadas por você.
            </PageSubtitle>
          </TextHeaderBox>
          <ButtonHeaderBox>
            <DashboardhMediumButton
              onClick={() => navigate(`/events/${id}/courtesy`)}
              color="#fff"
              background={SECONDARY_BLUE_01}
              height="48px"
              maxWidth="100%"
              variant="contained"
              width="204px"
            >
              {'Enviar Cortesias'}
            </DashboardhMediumButton>
          </ButtonHeaderBox>
        </PageHeaderBox>
        <FormDivider />
        <div ref={tabelaRef}>
          {error && (
            <ExceptionContainer height={400} margin={false}>
              <DashboardMessage
                isError={true}
                isImage={true}
                maintext={'Um erro aconteceu...'}
                subtext={'Já estamos trabalhando para corrigir o problema'}
              />
            </ExceptionContainer>
          )}
          {success && (
            <>
              <TableContainer>
                <CourtesyTable data={sentCortesiesData.data} />
                <br/>
                <TablePagination
                    pageCount={
                      sentCortesiesData.total_pages === 1
                      ? 0
                      : sentCortesiesData.total_pages
                    }
                    initialPage={page - 1}
                    onPageChange={handlePaginaChange}/>
              </TableContainer>
            </>
          )}
          {loading && (
            <ExceptionContainer height={400} margin={false}>
              <Loader />
            </ExceptionContainer>
          )}
        </div>
      </Container>
    </>
  )
}
